document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const selector = event.target.closest('[data-localization-select]');
  if (selector?.form) selector.form.submit();
});

const majbwrProductContext = document.querySelector('[data-product-context]');
if (majbwrProductContext) {
  const profile = JSON.parse(localStorage.getItem('majbwr_presence_profile') || '{"terms":{},"types":{},"highValue":0,"views":0}');
  const title = (majbwrProductContext.dataset.productTitle || '').toLowerCase();
  const tags = (majbwrProductContext.dataset.productTags || '').toLowerCase();
  const type = (majbwrProductContext.dataset.productType || '').toLowerCase();
  const price = Number(majbwrProductContext.dataset.productPrice || 0);
  ['sapphire','soaring','sovereign','black','gold','camo','camouflage','oversized','iced out','empire','core form','pure form'].forEach((term) => {
    if (`${title} ${tags}`.includes(term)) profile.terms[term] = (profile.terms[term] || 0) + 1;
  });
  if (type) profile.types[type] = (profile.types[type] || 0) + 1;
  if (price >= 150000) profile.highValue = (profile.highValue || 0) + 1;
  profile.views = (profile.views || 0) + 1;
  localStorage.setItem('majbwr_presence_profile', JSON.stringify(profile));
}

document.querySelectorAll('[data-recommendation-grid]').forEach((grid) => {
  const profile = JSON.parse(localStorage.getItem('majbwr_presence_profile') || '{"terms":{},"types":{},"highValue":0,"views":0}');
  if (!profile.views) return;
  const score = (card) => {
    const text = `${card.dataset.title || ''} ${card.dataset.tags || ''}`.toLowerCase();
    const type = (card.dataset.type || '').toLowerCase();
    const price = Number(card.dataset.price || 0);
    let value = profile.types[type] || 0;
    Object.entries(profile.terms || {}).forEach(([term, count]) => { if (text.includes(term)) value += count * 3; });
    if ((profile.highValue || 0) >= 2 && price < 150000) value -= 8;
    return value;
  };
  Array.from(grid.querySelectorAll('[data-smart-product]'))
    .sort((a, b) => score(b) - score(a))
    .forEach((card) => grid.appendChild(card));
});

class MajbwrProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.price = this.closest('.product__info')?.querySelector('[data-product-price]');
    this.button = this.querySelector('[data-add-to-cart]');
    this.lowStock = this.closest('.product__info')?.querySelector('[data-low-stock]');
    this.stickyPrice = document.querySelector('[data-sticky-price]');
    this.stickyButton = document.querySelector('[data-sticky-add]');
    this.variants = JSON.parse(this.querySelector('[data-variants-json]')?.textContent || '[]');
    this.optionInputs = Array.from(this.querySelectorAll('[data-option-position]'));

    this.optionInputs.forEach((input) => {
      input.addEventListener('change', () => this.updateVariant());
    });
  }

  selectedOptions() {
    const selected = [];

    this.optionInputs.forEach((input) => {
      if (input.checked) selected[Number(input.dataset.optionPosition) - 1] = input.value;
    });

    return selected;
  }

  updateVariant() {
    const selected = this.selectedOptions();
    const variant = this.variants.find((item) => {
      return item.options.every((option, index) => option === selected[index]);
    });

    this.updateOptionLabels();

    if (!variant) {
      if (this.variantInput) this.variantInput.value = '';
      if (this.button) {
        this.button.disabled = true;
        this.button.textContent = this.button.dataset.unavailableText;
      }
      return;
    }

    if (this.variantInput) this.variantInput.value = variant.id;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    if (this.price) this.price.textContent = this.formatMoney(variant.price);
    if (this.stickyPrice) this.stickyPrice.textContent = this.formatMoney(variant.price);
    if (this.button) {
      this.button.disabled = !variant.available;
      this.button.textContent = variant.available
        ? this.button.dataset.availableText
        : this.button.dataset.soldOutText;
    }
    if (this.stickyButton) {
      this.stickyButton.disabled = !variant.available;
      this.stickyButton.textContent = variant.available
        ? this.button.dataset.availableText
        : this.button.dataset.soldOutText;
    }

    this.updateLowStock(variant);
  }

  updateLowStock(variant) {
    if (!this.lowStock) return;
    const threshold = Number(this.lowStock.dataset.threshold || 0);
    const quantity = Number(variant.inventory_quantity || 0);
    const managed = Boolean(variant.inventory_management);
    const genuinelyLow = managed && variant.inventory_policy === 'deny' && quantity > 0 && quantity <= threshold;
    this.lowStock.hidden = !genuinelyLow;
    if (genuinelyLow) {
      this.lowStock.textContent = this.lowStock.dataset.messageTemplate.replace('__COUNT__', quantity);
    }
  }

  updateOptionLabels() {
    this.optionInputs.forEach((input) => {
      if (!input.checked) return;
      const label = this.querySelector(`[data-option-label="${input.dataset.optionPosition}"]`);
      if (label) label.textContent = input.value;
    });
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'AUD'
    }).format(cents / 100);
  }
}

if (!customElements.get('majbwr-product-form')) {
  customElements.define('majbwr-product-form', MajbwrProductForm);
}

document.querySelectorAll('[data-gallery-thumb]').forEach((thumbnail) => {
  thumbnail.addEventListener('click', () => {
    const image = thumbnail.closest('.product__media')?.querySelector('.product__primary-image');
    if (!image) return;

    image.src = thumbnail.dataset.gallerySrc;
    image.removeAttribute('srcset');
    image.alt = thumbnail.dataset.galleryAlt || '';

    thumbnail.closest('.product__thumbs')?.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
      const selected = item === thumbnail;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  });
});

document.querySelectorAll('[data-product-zoom]').forEach((button) => {
  button.addEventListener('click', () => {
    const productMedia = button.closest('.product__media');
    const source = productMedia?.querySelector('.product__primary-image');
    const dialog = productMedia?.querySelector('[data-product-zoom-dialog]');
    const zoomImage = dialog?.querySelector('.product-zoom__image');
    if (!source || !dialog || !zoomImage) return;

    zoomImage.src = source.currentSrc || source.src;
    zoomImage.alt = source.alt;
    dialog.showModal();
  });
});

document.querySelectorAll('[data-product-zoom-close]').forEach((button) => {
  button.addEventListener('click', () => button.closest('dialog')?.close());
});

document.querySelectorAll('[data-sticky-add]').forEach((button) => {
  button.addEventListener('click', () => document.querySelector('[data-add-to-cart]')?.click());
});

document.querySelectorAll('[data-wishlist-button]').forEach((button) => {
  const productId = String(button.dataset.productId);
  let wishlist = JSON.parse(localStorage.getItem('majbwr_wishlist') || '[]');

  const update = () => {
    const active = wishlist.includes(productId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.textContent = active ? button.dataset.removeText : button.dataset.addText;
  };

  update();
  button.addEventListener('click', () => {
    wishlist = wishlist.includes(productId)
      ? wishlist.filter((id) => id !== productId)
      : [...wishlist, productId];
    localStorage.setItem('majbwr_wishlist', JSON.stringify(wishlist));
    update();
  });
});

document.querySelectorAll('[data-delivery-estimate]').forEach((element) => {
  const addBusinessDays = (date, days) => {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
    }
    return result;
  };

  const format = (date) => new Intl.DateTimeFormat(document.documentElement.lang || 'en-AU', {
    day: 'numeric',
    month: 'short'
  }).format(date);
  const now = new Date();
  const minimum = addBusinessDays(now, Number(element.dataset.minDays || 7));
  const maximum = addBusinessDays(now, Number(element.dataset.maxDays || 12));
  element.textContent = `${element.dataset.prefix}: ${format(minimum)}–${format(maximum)}`;
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-quick-add-form]');
  if (!form) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[data-quick-add-status]');
  const originalText = button?.textContent;

  if (button) button.disabled = true;

  try {
    const response = await fetch(`${form.action}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Quick add failed');

    const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    document.querySelectorAll('.cart-count').forEach((count) => {
      count.textContent = cart.item_count;
      count.setAttribute('aria-label', `${cart.item_count} items in bag`);
    });

    if (status) status.textContent = form.dataset.addedText;
    if (button) button.textContent = button.dataset.successText;
  } catch (error) {
    if (status) status.textContent = form.dataset.errorText;
  } finally {
    window.setTimeout(() => {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 1400);
  }
});

document.addEventListener('keyup', (event) => {
  if (event.key === 'Tab') document.body.classList.add('keyboard-user');
});
